import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { PreProjetoExportarService } from '../services/pre-projeto-exportar.service';

@Injectable({
  providedIn: 'root',
})
export class PreProjetoExportarResolver implements Resolve<boolean> {
  constructor(private service: PreProjetoExportarService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getProcess();
  }
}
